import * as React from 'react';
import { Form } from 'react-bootstrap';
import * as _ from 'lodash'
import { copyObject, randomId } from '../utils';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
export interface ItemCheckbox {
    value: string
    label: string
    checked: boolean
    disabled?: boolean
}
export type ICheckBoxListUIProps = {
    data: Array<ItemCheckbox>
    className?: string
    onCheckBoxPress?(value: string, checked: boolean)
    inline?: boolean
    type?: "checkbox" | "radio"
}

const CheckBoxListUI: React.FC<ICheckBoxListUIProps> = (props) => {
    const [currentData, setCurrentData] = React.useState([])

    React.useEffect(() => {
        if (!_.isEqual(props.data, currentData)) {
            setCurrentData(props.data)
        }

    }, [props.data]);


    const onCheckBoxPress = (index, item, event) => {
        let cloneData = copyObject(currentData)
        cloneData[index].checked = !cloneData[index].checked
        let checked = cloneData[index].checked
        setCurrentData(cloneData)
        if (props.onCheckBoxPress) {
            props.onCheckBoxPress(item.value, checked)
        }

    }

    /**
     * 
     */
    const renderCheckBoxListUI = () => {
        const groupid = randomId();
        if (_.isArray(currentData)) {
            return currentData.map((item: ItemCheckbox, index) => {
                let className = `form-control ${props.className}`
                return (
                    <FormGroup>
                        <FormControlLabel
                            checked={item.checked}
                            disabled={item.disabled}
                            control={<Checkbox  />}
                            label={item?.label} 
                            onChange={(event) => onCheckBoxPress(index, item, event)}
                            />
                        {/* <Checkbox
                            disabled={item.disabled}
                            // custom
                            // inline={props.inline}
                            id={`${props.inline ? "custom-inline-" : "custom-"}${item.value}-${index}-${groupid}`}
                            key={index}
                            // label={item.label}
                            onChange={(event) => onCheckBoxPress(index, item, event)}
                            checked={item.checked}
                        // className={className}
                        // type={"checkbox"}
                        /> */}
                    </FormGroup>

                )
            })

        }
    }
    return (
        <div>

            {renderCheckBoxListUI()}

        </div>
    );
}

CheckBoxListUI.defaultProps = {
    type: "checkbox"
}
export default CheckBoxListUI;
export { CheckBoxListUI };